export const annotationsKeys = {
  annotations: () => ['ANNOTATIONS'] as const,
  annotation: (annotationId: number | string) =>
    [...annotationsKeys.annotations(), annotationId] as const,
  templates: () => ['TEMPLATES'] as const,
  template: (templateId: number | string) =>
    [...annotationsKeys.templates(), templateId] as const,
};
